import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'loginRoot',
    templateUrl: './loginRoot.html',
    standalone: false
})
export class LoginRootComponent implements OnInit{
  rootdivstyle = ``

  ngOnInit() {
    this.rootdivstyle = `display: flex; flex-direction: row; background: ${localStorage.getItem('primaryColor')}; height: 100vh; align-items: center; overflow: auto; overflow-x: hidden; position: relative; z-index: 0;`
  }

  protected readonly localStorage = localStorage;
}
